import { TranslationKey, useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement, ReactNode } from 'react';
interface IProps {
  label: TranslationKey;
  children: ReactNode;
}

export const PersonalInformationRow = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  return (
    <div className='list-row'>
      <div className='left'>{t(props.label)}</div>
      <div className='right'>{props.children}</div>
    </div>
  );
});
